import * as PIXI from "pixi.js";

import { TGameAssetAlias } from "@src/game/screens/GameScreen";
import { TorchView } from "@src/game/screens/components/Torch";
import { IView } from "@src/core/game/components/IView";
import { Assets } from "@src/core/assets/Assets";
import gsap from "gsap";
import { EventSystem } from "@src/core/events/EventSystem";
import { constants } from "@src/game/Constants";

export class BonusBackground implements IView {
  private _view: PIXI.Container = new PIXI.Container();
  public get view(): PIXI.Container {
    return this._view;
  }

  private _torchLeft!: TorchView;
  private _torchRight!: TorchView;
  private _backgroundHorizontalBonus!: PIXI.Sprite;

  public constructor() {
    this._initializeAssets();
    this._parentAssets();

    EventSystem.addListener(
      constants.GameEvents.LANDSCAPE_LAYOUT_REQUESTED,
      this._onLandscapeLayoutRequested.bind(this),
    );

    EventSystem.addListener(
      constants.GameEvents.PORTRAIT_LAYOUT_REQUESTED,
      this._onPortraitLayoutRequested.bind(this),
    );
  }

  _onLandscapeLayoutRequested() {
    this._torchRight.view.position.set(450, 200);
  }
  _onPortraitLayoutRequested() {
    this._torchRight.view.position.set(150, 200);
  }

  public fadeOut(immediate: boolean = false): void {
    if (immediate) {
      this._view.alpha = 0;
    } else {
      gsap.to(this._view, { alpha: 0.0, duration: 0.75 });
    }
  }

  public fadeIn(): void {
    gsap.to(this._view, { alpha: 1.0, duration: 0.75 });
  }

  private _initializeAssets(): void {
    this._torchLeft = new TorchView();
    this._torchLeft.view.position.set(-450, 200);

    this._torchRight = new TorchView();
    this._torchRight.view.position.set(450, 200);
    this._torchRight.view.scale.set(-1, 1);

    this._backgroundHorizontalBonus = new PIXI.Sprite(
      Assets.getAsset<TGameAssetAlias>("bonusBgHorizontalImg"),
    );
    this._backgroundHorizontalBonus.anchor.set(0.5);
  }

  private _parentAssets(): void {
    this._view.addChild(this._backgroundHorizontalBonus);
    this._view.addChild(this._torchLeft.view);
    this._view.addChild(this._torchRight.view);
  }
}
